import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Container, Col } from "react-bootstrap";
import "../CodeOverview/CodeOverview.scss";
import "./CodeSpecification.scss";
import ReactMarkdown from "react-markdown";
import Scrollbars from "react-custom-scrollbars-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faDownload, faCheck, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "../../common-components/button/Button.jsx";
import { setShowSpecification } from "../../state/reducers/CodeSpecification";

function Specification() {
  const specificationData = useSelector((state) => state.CodeSpecification?.specification);
  const isLoading = useSelector((state) => state.CodeSpecification.loading);
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch()

  const extractFilename = (fullPath) => {
    return fullPath.split("\\").pop().split("/").pop();
  };

  const copyToClipboard = () => {
    const textToCopy = specificationData.map(fileSpec => {
      const fullPath = Object.keys(fileSpec)[0];
      const filename = extractFilename(fullPath);
      const specContent = Object.values(fileSpec)[0];
      return `File Name: ${filename}\n\nSpecification:\n${specContent}\n\n`;
    }).join("");

    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
      
      // Reset the icon after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }, (err) => {
      console.error("Could not copy text: ", err);
    });
  };

  const downloadResult = () => {
    const textToDownload = specificationData.map(fileSpec => {
      const fullPath = Object.keys(fileSpec)[0];
      const filename = extractFilename(fullPath);
      const specContent = Object.values(fileSpec)[0];
      return `File Name: ${filename}\n\nSpecification:\n${specContent}\n\n`;
    }).join("");

    const element = document.createElement("a");
    const file = new Blob([textToDownload], {type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = "specificationData.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="page-wrapper code-overview-page">
      <Container fluid>
        <Row>
          <Col>
            {!isLoading && (
              <div className="content-wrap">
                <h2 className="page-title">Code Specification</h2>
                {specificationData && specificationData.length > 0 ? (
                  <div className="code-overview-wrapper">
                    <Row>
                      <Col>
                        <div className="overview-text-wrapper position-relative">
                          <button className="copy-btn" onClick={copyToClipboard}>
                            <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="copy-icon"/> <span>Copy</span>
                          </button>
                          <Scrollbars>
                            {specificationData.map((fileSpec, index) => {
                              const fullPath = Object.keys(fileSpec)[0];
                              const filename = extractFilename(fullPath);
                              const specContent = Object.values(fileSpec)[0];
                            
                              return (
                                <div className="spec-content" key={index}>
                                  <h2 className="filename">File Name : {filename}</h2>
                                  <h3>Specification</h3>
                                  <ReactMarkdown className="overview-text spec-text mb-4">
                                    {specContent}
                                  </ReactMarkdown>
                                </div>
                              );
                            })}
                          </Scrollbars>
                        </div>
                        <div className="text-end">
                          <CustomButton label={<><FontAwesomeIcon icon={faAngleLeft} className="dld-icon" /> <span>Back</span></>} onClick={() => dispatch(setShowSpecification(false))} className="back-btn" />
                          <button className="download-btn me-0" onClick={downloadResult}>
                            <FontAwesomeIcon icon={faDownload} className="dld-icon" /> <span>Download Code Specification</span>
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>  
                ) : (
                  <div className="err-msg">Unable to process your request. Please verify all required information is provided correctly and try again.</div>
                )}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Specification;